import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PATHS } from './path';

import ProtectedRoute from '../components/common/ProtectedRoute';
import PermissionRoute from '../components/common/PermissionRoute';
import Landing from '../pages/Landing';
import PlanDetails from '../pages/public/PlanDetails';
import VerifyInvoice from '../pages/public/VerifyInvoice';
import Login from '../pages/user/Login';
import Register from '../pages/user/Register';
import Dashboard from '../pages/user/Dashboard';
import Customers from '../pages/user/Customers';
import AddCustomer from '../pages/user/AddCustomer';
import Ledger from '../pages/user/Ledger';
import AddTransaction from '../pages/user/AddTransaction';
import Transactions from '../pages/user/Transactions';
import CreateInvoice from '../pages/user/CreateInvoice';
import Reports from '../pages/user/Reports';
import Businesses from '../pages/user/Businesses';
import Payments from '../pages/user/Payments';
import Products from '../pages/user/Products';
import Settings from '../pages/user/Settings';
import Mailbox from '../pages/user/Mailbox';
import ComposeMail from '../pages/user/ComposeMail';
import Staff from '../pages/user/Staff';
import Employees from '../pages/user/Employees';
import EmployeeForm from '../pages/user/EmployeeForm';
import EmployeeLedger from '../pages/user/EmployeeLedger';
import BulkAttendance from '../pages/user/BulkAttendance';
import QRScanner from '../pages/user/QRScanner';
import Pricing from '../pages/user/Pricing';
import BillingHistory from '../pages/user/BillingHistory';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import PaymentCheckout from '../pages/user/PaymentCheckout';

const RouterComponent = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path={PATHS.LANDING} element={<Landing />} />
      <Route path="/verify/:id" element={<VerifyInvoice />} />
      <Route path="/pricing-details" element={<PlanDetails />} />
      <Route path={PATHS.LOGIN} element={<Login />} />
      <Route path={PATHS.REGISTER} element={<Register />} />
      <Route path="/pay/:orderId" element={<PaymentCheckout />} />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path={PATHS.DASHBOARD} element={<Dashboard />} />
          <Route path={PATHS.CUSTOMERS} element={<PermissionRoute permission="customers"><Customers /></PermissionRoute>} />
          <Route path={PATHS.ADD_CUSTOMER} element={<PermissionRoute permission="customers"><AddCustomer /></PermissionRoute>} />
          <Route path={PATHS.LEDGER} element={<PermissionRoute permission="customers"><Ledger /></PermissionRoute>} />
          <Route path={PATHS.ADD_TRANSACTION} element={<PermissionRoute permission="transactions"><AddTransaction /></PermissionRoute>} />
          <Route path={PATHS.TRANSACTIONS} element={<PermissionRoute permission="transactions"><Transactions /></PermissionRoute>} />
          <Route path="/create-invoice" element={<PermissionRoute permission="transactions"><CreateInvoice /></PermissionRoute>} />
          <Route path="/create-invoice/:id" element={<PermissionRoute permission="transactions"><CreateInvoice /></PermissionRoute>} />
          <Route path="/edit-invoice/:invoiceId" element={<PermissionRoute permission="transactions"><CreateInvoice /></PermissionRoute>} />
          <Route path={PATHS.REPORTS} element={<PermissionRoute permission="reports"><Reports /></PermissionRoute>} />
          <Route path="/businesses" element={<Businesses />} />
          <Route path={PATHS.PAYMENTS} element={<PermissionRoute permission="payments"><Payments /></PermissionRoute>} />
          <Route path={PATHS.PRODUCTS} element={<PermissionRoute permission="inventory"><Products /></PermissionRoute>} />
          <Route path={PATHS.SETTINGS} element={<PermissionRoute permission="settings"><Settings /></PermissionRoute>} />
          <Route path={PATHS.STAFF} element={<PermissionRoute permission="staff"><Staff /></PermissionRoute>} />
          <Route path="/mailbox" element={<Mailbox />} />
          <Route path="/mailbox/compose" element={<ComposeMail />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/employees/add" element={<EmployeeForm />} />
          <Route path="/employees/edit/:id" element={<EmployeeForm />} />
          <Route path="/employees/:id" element={<EmployeeLedger />} />
          <Route path="/attendance" element={<BulkAttendance />} />
          <Route path="/scanner" element={<QRScanner />} />
          <Route path={PATHS.PRICING} element={<Pricing />} />
          <Route path={PATHS.BILLING} element={<BillingHistory />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to={PATHS.DASHBOARD} />} />
    </Routes>
  );
};

export default RouterComponent;
